document.addEventListener('turbolinks:load', function () {
  // 開発環境での開発スピードを上げるため青木の開発環境でのみ
  // manage/app/javascript/packs内の本jsファイルを走らせない
  if ((location.href.includes('dev-manage-ssl.platta.jp') || location.href.includes('http://18.177.103.115:3004')) && !location.href.includes('?dev27aoki')) {
    console.log('dev環境 public.jsを使用');
    return;
  }

  const ERROR_MSG = 'エラー！ 処理を完了できませんでした\n時間おいて再度実行しても、このエラーが修正されない場合は\nお手数ですがサポートチームにお問い合わせください';
  const MAIL_PATTERN = /^[a-zA-Z0-9_+-]+(.[a-zA-Z0-9_+-]+)*@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.)+[a-zA-Z]{2,}$/;
  const PASSWORD_PATTERN = /([0-9].*[a-zA-Z]|[a-zA-Z].*[0-9])/;

  const DOMAIN = $('#pl_domain').val();

  let current_url = location.href;

  //############################################################
  // タブの切替
  //############################################################
  $(function () {
    $('.hash_tag_communication__tab').on('click', function () {
      $('.hash_tag_communication__tab, .hash_tag_communication__panel').removeClass('active');

      $(this).addClass('active');

      let index = $('.hash_tag_communication__tab').index(this);
      $('.hash_tag_communication__panel').eq(index).addClass('active');
    });
  });

  //############################################################
  // テキストをクリップボードにコピーする
  //############################################################
  $(function () {
    $('.hashtag_list_permission__copy').on('click', function () {
      $(this).find('.span_copy').text('Copied');
      // const copied_text = $(this).next().text();
      // text()ではなく、val()で現在のテキストを取得できる
      const copied_text = $(this).next().val();
      setTimeout(() => {
        $(this).find('.span_copy').text('Copy');
      }, 2000);

      // クリップボードにコピー
      navigator.clipboard.writeText(copied_text);
    });
  });

  //############################################################
  // localStorage - フリーコメントを保存する
  //############################################################
  $(function () {
    // フリーコメント一覧
    let lstorage_free_comment_one;
    let lstorage_free_comment_two;

    if (localStorage) {
      if (localStorage.getItem('free_comment_one')) {
        lstorage_free_comment_one = localStorage.getItem('free_comment_one');
        $(`#free_comment_1`).text(lstorage_free_comment_one);
      }

      if (localStorage.getItem('free_comment_two')) {
        lstorage_free_comment_two = localStorage.getItem('free_comment_two');
        $(`#free_comment_2`).text(lstorage_free_comment_two);
      }

      // 配列をローカルストレージから取得する
      // lstorage_hashtag_list = localStorage.getItem(
      //   `${current_display_type}_hashtag_list`
      // );
    } // end of if (localStorage) {

    $('.hashtag_list_permission__save').on('click', function () {
      const this_el = $(this);
      this_el.find('.span_free_comment_save').text('保存しました。');
      // const saved_text = this_el.next().text();
      // text()ではなく、val()で現在のテキストを取得できる
      const saved_text = this_el.parent().find('textarea').val();
      if (this_el.attr('id') == 'save_free_comment_one') {
        localStorage.setItem('free_comment_one', saved_text);
      } else if (this_el.attr('id') == 'save_free_comment_two') {
        localStorage.setItem('free_comment_two', saved_text);
      }

      setTimeout(() => {
        this_el.find('.span_free_comment_save').text('コメントを保存');
      }, 2000);
    });
  });

  //############################################################
  // ファイルをダウンロードしたときのファイル名に現在時刻を拡張子の前につける
  //############################################################
  const time_now_as_YYYYMMDDHHMMSS = function () {
    let date = new Date();
    let year = date.getFullYear();
    let month = ('0' + (date.getMonth() + 1)).slice(-2); // Months are 0-based in JavaScript
    let day = ('0' + date.getDate()).slice(-2);
    let hours = ('0' + date.getHours()).slice(-2);
    let minutes = ('0' + date.getMinutes()).slice(-2);
    let seconds = ('0' + date.getSeconds()).slice(-2);

    let time_now = year + month + day + hours + minutes + seconds;

    return time_now;
  };

  // # 特定の要素のテキストを一括で変更する カルーセル用
  const change_btn_text = function (btn_element, text) {
    $.each(btn_element, function (indexInArray, button) {
      $(button).text(text);
    });
  };

  // 御礼を送信しましたボタンクリック時にラベルの状態を変更 + dbの許可申請状況を更新する処理
  const done_thanks_message = function (permission_state_id, sns_post_id, parent_media_id = '') {
    // すでに御礼を送信済だった場合はあとの処理を走らせない
    if (permission_state_id == 8) {
      $('.hashtag_list_thanks__done_button').css({ 'pointer-events': 'none', background: 'gray' });
      $('.hashtag_list_thanks__done_button').css('pointer-events', 'none');
      $('.hashtag_list_thanks__done_button').text('御礼送信済み');
      return;
    } else {
      permission_state_id = 8;
      $('.hashtag_list_thanks__done_button').css({ 'pointer-events': 'none', background: 'orange' });
      $('.hashtag_list_thanks__done_button').css('pointer-events', 'auto');
      $('.hashtag_list_thanks__done_button').text('御礼を送信しました');
    }

    // return;
    // 別のタブ内の同じボタンにも同じイベントを設定し、全てのボタンの状態を同じにする
    $('.hashtag_list_thanks__done_button').each(function (hp_index, element) {
      $(element).off('click');
      $(element).on('click', function (event) {
        event.stopPropagation();

        $.ajax({
          type: 'POST',
          url: DOMAIN + '/change_permission_state',
          data: {
            permission_state_id: permission_state_id,
            sns_post_id: sns_post_id,
            sns_post_parent_media_id: parent_media_id,
          },
          dataType: 'json',
          success: function (ugc_permission) {
            $(element).text('ラベルを御礼済みに変更しました');
            $(element).css({ background: 'darkblue' });
          }, // Added comma here
          error: function (jqXHR, textStatus, errorThrown) {
            alert('予期しないエラーが発生いたしました。再度ページを読み込んでください。');
          },
          complete: function () {
            setTimeout(() => {
              location.reload();
            }, 1000);
          },
        }); // end of ajax
      }); // end of element.addEventListener("click", function (event) {
    }); // end of $(".hashtag_list_permission__done_button").each(function (
  };

  // ¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥ モーダル  ¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥
  $(function () {
    $('.ugc_permission_btn')
      .off()
      .on('click', function (e) {
        $('body').css({ overflow: 'hidden' });
        let permission_state_btn = $(this);
        let sns_post_id = permission_state_btn.attr('data-id');
        let sns_post_state = permission_state_btn.attr('data-permission_state');
        let parent_media_id = permission_state_btn.attr('data-parent_media_id');

        let post_tag_card = permission_state_btn.next();
        // .post_tag_card の permalinkを取得
        let ugc_communication_permalink = post_tag_card.find('a').attr('href');

        let ugc_communication_media_src = post_tag_card.find('img');

        let media_container = $('.hashtag_list_permission__media_container');

        // 御礼を送信しましたボタンクリック時にラベルの状態を変更 + dbの許可申請状況を更新する処理
        done_thanks_message(sns_post_state, sns_post_id, parent_media_id);

        // メッセージを投稿するボタンにインスタグラムのurlを設定する - 直接UGC利用許可のコメントをできるようにするため
        $('.hashtag_list_permission__done_button_href').attr('href', ugc_communication_permalink);

        // モーダル内のボタンの状態変化を管理
        let permission_done_btn = $('.hashtag_list_permission__done_button');

        let permission_done_buttons = $('.hashtag_list_permission__done_button');

        // 初期化
        permission_done_btn.css('pointer-events', 'auto');

        if (sns_post_state == 0 || sns_post_state == -1) {
          permission_done_btn.removeClass('btn_gray_active');
          permission_done_btn.text('許可申請を送信しました');
          change_btn_text(permission_done_btn, '許可申請を送信しました');
        } else if (sns_post_state == 1) {
          permission_done_btn.addClass('btn_gray_active');
          permission_done_btn.text('許可申請済');
          permission_done_btn.css('pointer-events', 'none');
          change_btn_text(permission_done_btn, '許可申請済');
        } else if (sns_post_state != 0 && sns_post_state > 1) {
          permission_done_btn.addClass('btn_gray_active');
          permission_done_btn.text('許可申請済');
          change_btn_text(permission_done_btn, '許可申請済');
          permission_done_btn.css('pointer-events', 'none');
        }

        const prependMedia = function (tagName, src, permalink) {
          let media;

          let cmm_status_string_for_pic;

          if (sns_post_state == 0) {
            cmm_status_string_for_pic = '許可申請前';
          } else if (sns_post_state == 1) {
            cmm_status_string_for_pic = '回答待ち';
          } else if (sns_post_state == 2) {
            cmm_status_string_for_pic = '回答待ち(1週間以上)';
          } else if (sns_post_state == 3) {
            cmm_status_string_for_pic = '返信要確認';
          } else if (sns_post_state == 4) {
            cmm_status_string_for_pic = '掲載可能';
          } else if (sns_post_state == 5) {
            cmm_status_string_for_pic = '掲載不可';
          } else if (sns_post_state == 6) {
            cmm_status_string_for_pic = '連携済み';
          } else if (sns_post_state == 7) {
            cmm_status_string_for_pic = '連携解除済み';
          } else if (sns_post_state == -1) {
            cmm_status_string_for_pic = 'コミュニケーション管理から削除済み';
          } else {
            cmm_status_string_for_pic = '';
          }

          let closeTag = tagName == 'video' ? `</${tagName}>` : '';
          media = `<div class="hashtag_list_permission__media_block" data-id=''>
                <a href="${permalink}">
                <${tagName} class="hashtag_list_permission__media" data-id=${common_media_count_up} src="${src}" />${closeTag}
                </a>

                <p class="hashtag_list_permission__pic_status" data-permission_state =${sns_post_state} >${cmm_status_string_for_pic}</p>
                </div>`;

          media_container.prepend(media);
        };

        let media_type;

        // モーダル内で表示する画像 or video のsrcを取得する
        if (ugc_communication_media_src.length > 0) {
          ugc_communication_media_src = post_tag_card.find('img').attr('src');
          media_type = 'img';
        } else if (ugc_communication_media_src.length == 0) {
          ugc_communication_media_src = post_tag_card.find('video').attr('src');
          media_type = 'video';
        }

        // 毎回appendした要素を削除する
        $('.hashtag_list_permission__media_block').remove();

        // モーダル内にメディアを表示させる
        prependMedia(media_type, ugc_communication_media_src, ugc_communication_permalink);

        // // $(".hashtag_list_permission__caption")[video_order].text("New caption text");
        // $(".hashtag_list_permission__caption").text(selected_description);

        $('.hashtag_list_permission__overlay').addClass('active');
        $('.hashtag_list_permission').addClass('active');

        //  閉じる所作
        $('.hashtag_list_permission__fa-x, .hashtag_list_permission__close, .hashtag_list_permission__overlay, #hashtag_list_permission__close_button')
          .off()
          .on('click', function () {
            $('.hashtag_list_permission__overlay').removeClass('active');
            $('.hashtag_list_permission').removeClass('active');
            $('body').css({ overflow: 'auto' });
          });

        // ###################################################
        // ハッシュタグ収集一覧 UGC許可申請ボタン コミュニケーション管理へ特定の投稿を反映させる
        // ###################################################
        // $(".hashtag_list_permission__done_button").on("click", function (event) {

        // 別のタブ内の同じボタンにも同じイベントを設定し、全てのボタンの状態を同じにする
        $('.hashtag_list_permission__done_button').each(function (hp_index, element) {
          $(element).off('click');
          $(element).on('click', function (event) {
            event.stopPropagation();

            // クリックした時刻(コメント送信時刻)を日本時間でmysqlでそのまま使える形で取得する ※    # ¥ DB側で勝手に日本時間をUTC時間に変更して保存する
            let currentTime = new Date();
            let options = { timeZone: 'Asia/Tokyo', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' };

            let sentJapanFormattedTime = currentTime.toLocaleString('en-US', options).replace(/, /g, ' ').replace(/\//g, '-');

            // Split date and time
            let dateAndTime = sentJapanFormattedTime.split(' ');

            // Split the date parts
            let dateParts = dateAndTime[0].split('-');

            // Reorder the date parts and reassemble the date and time
            sentJapanFormattedTime = `${dateParts[2]}-${dateParts[0]}-${dateParts[1]} ${dateAndTime[1]} ${dateAndTime[2]}`;

            permission_state_btn.css('pointer-events', 'none');
            permission_done_btn.css('pointer-events', 'none');

            $.ajax({
              type: 'POST',
              url: DOMAIN + '/move_ugc_to_communication',
              data: {
                sns_post_id: sns_post_id,
                sentJapanFormattedTime: sentJapanFormattedTime,
                sns_post_parent_media_id: parent_media_id,
              },
              dataType: 'json',
              success: function (ugc_permission) {
                // カルーセルの場合、まとめて複数の許可申請のボタンをグレイにする
                if (ugc_permission.carousel_parent_media_id) {
                  $(`[data-parent_media_id='${ugc_permission.carousel_parent_media_id}']`).css({ 'pointer-events': 'none', background: 'gray' });
                  $(`[data-parent_media_id='${ugc_permission.carousel_parent_media_id}']`).text('移動済み');
                }
                if (permission_state_btn.hasClass('btn_gray_active')) {
                  permission_state_btn.removeClass('btn_gray_active');
                  permission_done_btn.removeClass('btn_gray_active');
                } else {
                  permission_state_btn.addClass('btn_gray_active');
                  permission_done_btn.addClass('btn_gray_active');
                }

                if (ugc_permission.state == 0) {
                  permission_state_btn.text('許可申請');
                  permission_done_btn.text('許可申請を送信しました');
                  permission_done_btn.css('pointer-events', 'none');
                } else if (ugc_permission.state == 1) {
                  permission_state_btn.text('移動済み');
                  permission_done_btn.text('許可申請済');
                  permission_done_btn.css('pointer-events', 'none');
                } else if (ugc_permission.state != 0 && ugc_permission.state != 1) {
                  permission_state_btn.text(' -------- ');
                  permission_done_btn.text('許可申請済');
                  permission_done_btn.css('pointer-events', 'none');
                }
                setTimeout(() => {
                  permission_state_btn.css('pointer-events', 'auto');
                  // permission_done_btn.css('pointer-events', 'auto');
                }, 3000);
              }, // Added comma here
              error: function (jqXHR, textStatus, errorThrown) {
                alert('予期しないエラーが発生いたしました。再度ページを読み込んでください。');
                permission_state_btn.css('pointer-events', 'auto');
                permission_done_btn.css('pointer-events', 'auto');
              },
              complete: function () {
                // This code will run regardless of success or error
                // permission_state_btn.off();
                // $(".hashtag_list_permission__done_button").off();
              },
            }); // end of ajax
          }); // end of element.addEventListener("click", function (event) {
        }); // end of $(".hashtag_list_permission__done_button").each(function (
      }); // end of $(".ugc_permission_btn").on("click", function (e) {
  });

  //  閉じる所作
  $('.hashtag_list_permission__fa-x, .hashtag_list_permission__close, .hashtag_list_permission__overlay, #hashtag_list_permission__close_button').on('click', function () {
    $('.hashtag_list_permission__overlay').removeClass('active');
    $('.hashtag_list_permission').removeClass('active');
    $('#hashtag_list_permission__close_button').removeClass('active');
  });

  // ¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥ モーダル END  ¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥
  // ラベルの状態を変更時のY軸の位置を記録する(その位置を現在のurlに含める)
  function updateURLWithScrollPosition() {
    let scrollPosition = $(window).scrollTop();

    // Create a new URL with the scroll position as a parameter
    let currentUrl = window.location.href;
    let newUrl = new URL(currentUrl);
    newUrl.searchParams.set('scroll_position', scrollPosition);

    // Change the current URL without reloading the page
    window.history.pushState({}, '', newUrl);
  }

  // ¥¥¥¥¥¥¥¥ main ステータスラベル変更 ¥¥¥¥¥¥¥¥¥¥¥¥

  // コミュニケーション管理でugcの利用許可の状態を色で表示する際の付け替え可能なクラス名一覧
  // selecter.removeClass()の複数の引数は , ではなく、半角空白で区切る
  const all_selected_ugc_state_color_css = 'selected_color_delete selected_color_waiting selected_color_waiting_seven_days selected_color_ok selected_color_ng selected_color_done selected_color_thanked';

  $('.cmm_select').on('change', function (event) {
    // let permission_state_id = $(".cmm_select option:selected").attr(
    //   "data-permission_state_id"
    // );
    // let sns_post_id = $(".cmm_select option:selected").attr("data-sns_post_id");

    let this_permission_state_label = $(this);
    let selectedOption = this_permission_state_label.find('option:selected');
    let permission_state_id = selectedOption.attr('data-permission_state_id');
    let sns_post_id = selectedOption.attr('data-sns_post_id');

    let sns_post_parent_media_id = selectedOption.attr('data-parent_media_id');
    // alert(sns_post_parent_media_id);

    this_permission_state_label.css('pointer-events', 'none');

    $.ajax({
      type: 'POST',
      url: DOMAIN + '/change_permission_state',
      data: {
        permission_state_id: permission_state_id,
        sns_post_id: sns_post_id,
        sns_post_parent_media_id: sns_post_parent_media_id,
      },
      dataType: 'json',
      success: function (response) {
        if (permission_state_id == 0) {
          this_permission_state_label.removeClass(all_selected_ugc_state_color_css);
          this_permission_state_label.addClass('selected_color_delete');
        } else if (permission_state_id == 1) {
          this_permission_state_label.removeClass(all_selected_ugc_state_color_css);
          this_permission_state_label.addClass('selected_color_waiting');
        } else if (permission_state_id == 2) {
          this_permission_state_label.removeClass(all_selected_ugc_state_color_css);
          this_permission_state_label.addClass('selected_color_waiting_seven_days');
        } else if (permission_state_id == 3) {
          this_permission_state_label.removeClass(all_selected_ugc_state_color_css);
          this_permission_state_label.addClass('selected_color_waiting');
        } else if (permission_state_id == 4) {
          this_permission_state_label.removeClass(all_selected_ugc_state_color_css);
          this_permission_state_label.addClass('selected_color_ok');
        } else if (permission_state_id == 5) {
          this_permission_state_label.removeClass(all_selected_ugc_state_color_css);
          this_permission_state_label.addClass('selected_color_ng');
        } else if (permission_state_id == 6) {
          this_permission_state_label.removeClass(all_selected_ugc_state_color_css);
          this_permission_state_label.addClass('selected_color_done');
          // * 7: 連携していたUGCをお客さんがUGCグループ設定画面で連携解除したもの ここでは管理しない
        } else if (permission_state_id == 8) {
          this_permission_state_label.removeClass(all_selected_ugc_state_color_css);
          this_permission_state_label.addClass('selected_color_thanked');
        }
      },
      fail: function (jqXHR, textStatus, errorThrown) {
        alert('予期しないエラーが発生いたしました。再度ページを読み込んでください。');
      },
      complete: function (jqXHR, textStatus, errorThrown) {
        this_permission_state_label.css('pointer-events', 'auto');
        // alert(
        //   `返信待ちUGC一覧のラベルの状態を要確認、掲載可能、掲載不可、連携済み
        //   本投稿のラベルの状態を自動的に"連携済み"に変更します。`.replace(/[ \t]/g, '')
        // );

        // ラベルの状態を変更時のY軸の位置を記録する(その位置を現在のurlに含める)
        // updateURLWithScrollPosition();

        //
        location.reload();
      },
    });
  });
  // ¥¥¥¥¥¥¥¥ main ステータスラベル変更 END ¥¥¥¥¥¥¥¥¥¥¥¥

  // // updateURLWithScrollPositionで取得した位置まで移動する (redirect時の初期位置を決定し、移動する)
  // function scroll_to_location() {
  //   let params = new URLSearchParams(window.location.search);
  //   let scrollPosition = params.get('scroll_position');
  //   if (scrollPosition) {
  //     alert(scrollPosition);
  //     $(window).scrollTop(parseInt(scrollPosition, 100));
  //   }
  // }

  // scroll_to_location();

  // ¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥
  // フィルター機能 返信取得済みUGC一覧
  // ¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥¥

  // ハッシュタグ検索一覧画面のカレンダーにて今日の日付しか入力できないようにする
  if ($('#cmm_main_initial_date')) {
    let today = new Date().toISOString().split('T')[0];
    // $('input[type="date"]').attr('max', today);
  }

  let lstorage_cmm_sub_ugc_urls_list;

  // localStorageにアイテムが存在した場合、デフォルトのテキストを書き換える処理
  const get_local_storage_item_overwrite_value = function (id_name) {
    if (localStorage.getItem(id_name)) {
      $(`#${id_name}`).val(localStorage.getItem(id_name));
      return localStorage.getItem(id_name);
    } else {
      return undefined;
    }
  };

  // localStorageにアイテムが存在した場合、チェックをつける処理
  const get_local_storage_item_checked = function (id_name) {
    if (localStorage.getItem(id_name)) {
      $(`#${id_name}`).prop('checked', true);
      return localStorage.getItem(id_name);
    } else {
      return undefined;
    }
  };

  //  ¥ localStorageでメディアタイプの初期チェック状態を管理する
  get_local_storage_item_checked('cmm_main_media_type_pic');
  get_local_storage_item_checked('cmm_main_media_type_carousel');
  get_local_storage_item_checked('cmm_main_media_type_video');

  //  ¥ localStorageでステータスの初期チェック状態を管理する
  get_local_storage_item_checked('cmm_main_status_need_confirm');
  get_local_storage_item_checked('cmm_main_status_ok_ugc');
  get_local_storage_item_checked('cmm_main_status_ng_ugc');
  get_local_storage_item_checked('cmm_main_status_done_ugc');
  get_local_storage_item_checked('cmm_main_status_cancel_ugc');
  get_local_storage_item_checked('cmm_main_status_thanked_ugc');

  //  ¥ localStorageでinput要素のテキスト状態を管理する
  get_local_storage_item_overwrite_value('cmm_main_username');
  get_local_storage_item_overwrite_value('cmm_main_comment_keyword');
  get_local_storage_item_overwrite_value('cmm_main_initial_date');
  get_local_storage_item_overwrite_value('cmm_main_end_date');
  get_local_storage_item_overwrite_value('cmm_main_per_page_num');

  // ugc_urlsをUGC検索欄にローカルストレージから自動で反映させる処理
  if (localStorage.getItem('cmm_main_ugc_urls_list')) {
    lstorage_cmm_main_ugc_urls_list = localStorage.getItem('cmm_main_ugc_urls_list');
    lstorage_cmm_main_ugc_urls_list = JSON.parse(lstorage_cmm_main_ugc_urls_list);
    lstorage_cmm_main_ugc_urls_list_str = lstorage_cmm_main_ugc_urls_list.join('\n');
    $('#cmm_main_ugc_urls').text(lstorage_cmm_main_ugc_urls_list_str);
  }

  //  ¥ localStorageでメディアタイプの初期チェック状態を管理する
  get_local_storage_item_checked('cmm_sub_media_type_pic');
  get_local_storage_item_checked('cmm_sub_media_type_carousel');
  get_local_storage_item_checked('cmm_sub_media_type_video');

  //  ¥ localStorageでステータスの初期チェック状態を管理する
  get_local_storage_item_checked('cmm_sub_status_waiting_reply');
  get_local_storage_item_checked('cmm_sub_status_waiting_seven_days');

  //  ¥ localStorageでinput要素のテキスト状態を管理する
  // get_local_storage_item_overwrite_value('cmm_sub_username'); なし
  get_local_storage_item_overwrite_value('cmm_sub_comment_keyword');
  get_local_storage_item_overwrite_value('cmm_sub_initial_date');
  get_local_storage_item_overwrite_value('cmm_sub_end_date');
  get_local_storage_item_overwrite_value('cmm_sub_per_page_num');

  // ugc_urlsをUGC検索欄にローカルストレージから自動で反映させる処理
  if (localStorage.getItem('cmm_sub_ugc_urls_list')) {
    lstorage_cmm_sub_ugc_urls_list = localStorage.getItem('cmm_sub_ugc_urls_list');
    lstorage_cmm_sub_ugc_urls_list = JSON.parse(lstorage_cmm_sub_ugc_urls_list);
    lstorage_cmm_sub_ugc_urls_list_str = lstorage_cmm_sub_ugc_urls_list.join('\n');
    $('#cmm_sub_ugc_urls').text(lstorage_cmm_sub_ugc_urls_list_str);
  }

  // フィルターの条件を抽出し、queryで飛ばす
  const set_all_filter_condition = function () {
    //////////////////////// main 返信取得済みUGC一覧 ////////////////////////////
    // 表示する期間
    let cmm_main_initial_date = $('#cmm_main_initial_date').val();
    let cmm_main_end_date = $('#cmm_main_end_date').val();

    // localStorage
    localStorage.setItem('cmm_main_initial_date', cmm_main_initial_date);
    localStorage.setItem('cmm_main_end_date', cmm_main_end_date);

    // フィルター: メディアタイプ
    let cmm_main_media_type_pic = $('#cmm_main_media_type_pic:checked').attr('id') || ''; // ない場合は undefined
    let cmm_main_media_type_carousel = $('#cmm_main_media_type_carousel:checked').attr('id') || ''; // ない場合は undefined
    let cmm_main_media_type_video = $('#cmm_main_media_type_video:checked').attr('id') || ''; // ない場合は undefined

    localStorage.setItem('cmm_main_media_type_pic', cmm_main_media_type_pic);
    localStorage.setItem('cmm_main_media_type_carousel', cmm_main_media_type_carousel);
    localStorage.setItem('cmm_main_media_type_video', cmm_main_media_type_video);

    // フィルター: ステータス
    let cmm_main_status_need_confirm = $('#cmm_main_status_need_confirm:checked').attr('id') || ''; // ない場合は undefined
    let cmm_main_status_ok_ugc = $('#cmm_main_status_ok_ugc:checked').attr('id') || ''; // ない場合は undefined
    let cmm_main_status_ng_ugc = $('#cmm_main_status_ng_ugc:checked').attr('id') || ''; // ない場合は undefined
    let cmm_main_status_done_ugc = $('#cmm_main_status_done_ugc:checked').attr('id') || ''; // ない場合は undefined
    let cmm_main_status_cancel_ugc = $('#cmm_main_status_cancel_ugc:checked').attr('id') || ''; // ない場合は undefined
    let cmm_main_status_thanked_ugc = $('#cmm_main_status_thanked_ugc:checked').attr('id') || ''; // ない場合は undefined

    localStorage.setItem('cmm_main_status_need_confirm', cmm_main_status_need_confirm);
    localStorage.setItem('cmm_main_status_ok_ugc', cmm_main_status_ok_ugc);
    localStorage.setItem('cmm_main_status_ng_ugc', cmm_main_status_ng_ugc);
    localStorage.setItem('cmm_main_status_done_ugc', cmm_main_status_done_ugc);
    localStorage.setItem('cmm_main_status_cancel_ugc', cmm_main_status_cancel_ugc);
    localStorage.setItem('cmm_main_status_thanked_ugc', cmm_main_status_thanked_ugc);

    // フィルター: ユーザーネーム検索
    let cmm_main_username = $('#cmm_main_username').val() || ''; // ない場合は undefined
    // フィルター: キャプション検索
    let cmm_main_comment_keyword = $('#cmm_main_comment_keyword').val() || ''; // ない場合は undefined

    localStorage.setItem('cmm_main_username', cmm_main_username);
    localStorage.setItem('cmm_main_comment_keyword', cmm_main_comment_keyword);

    // ハッシュタグ検索一覧ページ内に表示する投稿の数を取得する
    let cmm_main_per_page_num = $('#cmm_main_per_page_num option:selected').val();
    localStorage.setItem('cmm_main_per_page_num', cmm_main_per_page_num);

    // 投稿表示順切り替え
    let cmm_main_display_order = $('#cmm_main_display_order option:selected').val();
    localStorage.setItem('cmm_main_display_order', cmm_main_display_order);

    // cmm_main側のUGC検索URL一覧を取得する
    let cmm_main_ugc_urls = $('#cmm_main_ugc_urls').val();
    // 余分な空白等含む可能性あり

    cmm_main_ugc_urls_list = cmm_main_ugc_urls.split('\n'); // 空白だった場合の結果: ['']

    // 要素についているかもしれない前後の空白除去及び 'https://~ ' や "https://~ "などの ' や "を削除"
    cmm_main_ugc_urls_list = $.map(cmm_main_ugc_urls_list, function (url, idx) {
      return url.replace(/'/g, '').replace(/"/g, '').replace(/,/g, '').trim();
    });

    // 複数のデータ(配列)を保存したいためJSON形式のデータとして保存します
    ugc_urls_list_str = JSON.stringify(cmm_main_ugc_urls_list);
    localStorage.setItem(`cmm_main_ugc_urls_list`, ugc_urls_list_str);

    //////////////////// main 返信取得済みUGC一覧 END /////////////////////////////////////

    //////////////////////// sub 返信待ちUGC一覧 ////////////////////////////
    // 表示する期間
    let cmm_sub_initial_date = $('#cmm_sub_initial_date').val();
    let cmm_sub_end_date = $('#cmm_sub_end_date').val();

    // localStorage
    localStorage.setItem('cmm_sub_initial_date', cmm_sub_initial_date);
    localStorage.setItem('cmm_sub_end_date', cmm_sub_end_date);

    // フィルター: メディアタイプ
    let cmm_sub_media_type_pic = $('#cmm_sub_media_type_pic:checked').attr('id') || ''; // ない場合は undefined
    let cmm_sub_media_type_carousel = $('#cmm_sub_media_type_carousel:checked').attr('id') || ''; // ない場合は undefined
    let cmm_sub_media_type_video = $('#cmm_sub_media_type_video:checked').attr('id') || ''; // ない場合は undefined

    localStorage.setItem('cmm_sub_media_type_pic', cmm_sub_media_type_pic);
    localStorage.setItem('cmm_sub_media_type_carousel', cmm_sub_media_type_carousel);
    localStorage.setItem('cmm_sub_media_type_video', cmm_sub_media_type_video);

    // フィルター: ステータス
    let cmm_sub_status_waiting_reply = $('#cmm_sub_status_waiting_reply:checked').attr('id') || ''; // ない場合は undefined
    let cmm_sub_status_waiting_seven_days = $('#cmm_sub_status_waiting_seven_days:checked').attr('id') || ''; // ない場合は undefined

    localStorage.setItem('cmm_sub_status_waiting_reply', cmm_sub_status_waiting_reply);
    localStorage.setItem('cmm_sub_status_waiting_seven_days', cmm_sub_status_waiting_seven_days);

    // フィルター: ユーザーネーム検索 なし apiで返信待ちの状態のものは取得できないため
    // let cmm_sub_username = $('#cmm_sub_username').val() || '';

    // フィルター: キャプション検索
    let cmm_sub_comment_keyword = $('#cmm_sub_comment_keyword').val() || '';

    localStorage.setItem('cmm_sub_comment_keyword', cmm_sub_comment_keyword);

    // ハッシュタグ検索一覧ページ内に表示する投稿の数を取得する
    let cmm_sub_per_page_num = $('#cmm_sub_per_page_num option:selected').val();
    localStorage.setItem('cmm_sub_per_page_num', cmm_sub_per_page_num);

    // 投稿表示順切り替え
    let cmm_sub_display_order = $('#cmm_sub_display_order option:selected').val();
    localStorage.setItem('cmm_sub_display_order', cmm_sub_display_order);

    // cmm_sub側のUGC検索URL一覧を取得する
    let cmm_sub_ugc_urls = $('#cmm_sub_ugc_urls').val();
    // 余分な空白等含む可能性あり
    cmm_sub_ugc_urls_list = cmm_sub_ugc_urls.split('\n');

    // 要素についているかもしれない前後の空白除去及び 'https://~ ' や "https://~ "などの ' や "を削除"
    cmm_sub_ugc_urls_list = $.map(cmm_sub_ugc_urls_list, function (url, idx) {
      return url.replace(/'/g, '').replace(/"/g, '').replace(/,/g, '').trim();
    });

    //  複数のデータ(配列)を保存したいためJSON形式のデータとして保存します。
    ugc_urls_list_str = JSON.stringify(cmm_sub_ugc_urls_list);
    localStorage.setItem(`cmm_sub_ugc_urls_list`, ugc_urls_list_str);

    $.ajax({
      type: 'POST',
      url: DOMAIN + '/cmm_filter_hashtag_ugc',
      data: {
        cmm_main_ugc_urls_list: cmm_main_ugc_urls_list,
        cmm_sub_ugc_urls_list: cmm_sub_ugc_urls_list,
      },
      dataType: 'json',
      success: function (data) {
        // alert('success!');
        let url_query_path = `/communication_management?&cmm_main_initial_date=${cmm_main_initial_date}&cmm_main_end_date=${cmm_main_end_date}&cmm_main_media_type_pic=${cmm_main_media_type_pic}&cmm_main_media_type_carousel=${cmm_main_media_type_carousel}&cmm_main_media_type_video=${cmm_main_media_type_video}&cmm_main_status_need_confirm=${cmm_main_status_need_confirm}&cmm_main_status_ok_ugc=${cmm_main_status_ok_ugc}&cmm_main_status_ng_ugc=${cmm_main_status_ng_ugc}&cmm_main_status_done_ugc=${cmm_main_status_done_ugc}&cmm_main_status_cancel_ugc=${cmm_main_status_cancel_ugc}&cmm_main_status_thanked_ugc=${cmm_main_status_thanked_ugc}&cmm_main_username=${cmm_main_username}&cmm_main_comment_keyword=${cmm_main_comment_keyword}&cmm_main_per_page_num=${cmm_main_per_page_num}&cmm_main_display_order=${cmm_main_display_order}&cmm_main_ugc_urls_list=${cmm_main_ugc_urls_list}&cmm_sub_initial_date=${cmm_sub_initial_date}&cmm_sub_end_date=${cmm_sub_end_date}&cmm_sub_status_waiting_reply=${cmm_sub_status_waiting_reply}&cmm_sub_status_waiting_seven_days=${cmm_sub_status_waiting_seven_days}&cmm_sub_media_type_pic=${cmm_sub_media_type_pic}&cmm_sub_media_type_carousel=${cmm_sub_media_type_carousel}&cmm_sub_media_type_video=${cmm_sub_media_type_video}&cmm_sub_comment_keyword=${cmm_sub_comment_keyword}&cmm_sub_per_page_num=${cmm_sub_per_page_num}&cmm_sub_display_order=${cmm_sub_display_order}&stop=1&cmm_sub_ugc_urls_list=${cmm_sub_ugc_urls_list}`;

        if ($('#cmm_main_status_hidden').is(':checked')) {
          url_query_path += "&cmm_main_status_hidden=1";
        }

        location.href = url_query_path;
      },
      error: function (jqXHR, textStatus, errorThrown) {},
    });

    ///////////////////////////// sub 返信取得済みUGC一覧 END /////////////////////////////////////

    // get_hashtag_ids_names()が loopしないように &stop=1 を追加
    // let url_query_path = `/communication_management?&cmm_main_initial_date=${cmm_main_initial_date}&cmm_main_end_date=${cmm_main_end_date}&cmm_main_per_page_num=${cmm_main_per_page_num}&stop=1`;

    // return url_query_path;
  };

  $('.cmm_main__filter_btn').on('click', function () {
    set_all_filter_condition();
  });

  $('.cmm_sub__filter_btn').on('click', function () {
    set_all_filter_condition();
  });

  // ユーザーネーム / コメントキーワードのアイコンクリック時
  $('.cmm_input_search__click').on('click', function () {
    set_all_filter_condition();
  });

  // ユーザーネーム / コメントキーワードのEnter押下時
  $('.cmm_input_search__enter').keypress(function (e) {
    if (e.keyCode == 13) {
      set_all_filter_condition();
    }
  });

  // フィルター機能一括トグル toggle機能
  // タググループに紐付いた全てのタグをチェックする
  const cmm_sub__toggle_all = $('#cmm_sub__toggle_all');
  const cmm_sub__toggle_media_type = $('#cmm_sub__toggle_media_type');
  const cmm_sub__toggle_status = $('#cmm_sub__toggle_status');

  let all_sub_media_check_boxes = $('.cmm_sub__media_section input');
  let all_sub_status_check_boxes = $('.cmm_sub__status_section input');

  const cmm_main__toggle_all = $('#cmm_main__toggle_all');
  const cmm_main__toggle_media_type = $('#cmm_main__toggle_media_type');
  const cmm_main__toggle_status = $('#cmm_main__toggle_status');

  let all_main_media_check_boxes = $('.cmm_main__media_section input');
  let all_main_status_check_boxes = $('.cmm_main__status_section input');

  // 絞り込み条件をトグルする関数
  const toggle_filters = function (check_boxes, area_toggle) {
    $.each(check_boxes, function (index, el) {
      if (area_toggle.is(':checked')) {
        el.checked = true;
      } else {
        el.checked = false;
      }
    });
  };

  // 返信取得済みUGC一覧エリア
  cmm_main__toggle_all.on('change', function () {
    toggle_filters(all_main_media_check_boxes, cmm_main__toggle_all);
    toggle_filters(all_main_status_check_boxes, cmm_main__toggle_all);
  });
  cmm_main__toggle_media_type.on('change', function () {
    toggle_filters(all_main_media_check_boxes, cmm_main__toggle_media_type);
  });
  cmm_main__toggle_status.on('change', function () {
    toggle_filters(all_main_status_check_boxes, cmm_main__toggle_status);
  });

  // 返信待ちUGC一覧エリア
  cmm_sub__toggle_all.on('change', function () {
    toggle_filters(all_sub_media_check_boxes, cmm_sub__toggle_all);
    toggle_filters(all_sub_status_check_boxes, cmm_sub__toggle_all);
  });
  cmm_sub__toggle_media_type.on('change', function () {
    toggle_filters(all_sub_media_check_boxes, cmm_sub__toggle_media_type);
  });
  cmm_sub__toggle_status.on('change', function () {
    toggle_filters(all_sub_status_check_boxes, cmm_sub__toggle_status);
  });

  // コミュニケーション管理の説明
  // 検索条件の表示非表示 slideToggle -
  $('.cmm_how_to_use__accordion_filter').click(function () {
    $('.cmm_how_to_use__filter_container').slideToggle(300, function () {
      $(this).toggleClass('open');

      // The text change needs to happen here, after the 'open' class is toggled
      if ($(this).hasClass('open')) {
        $('.cmm_how_to_use__accordion_filter').text('本ページの説明を非表示にする');
      } else {
        $('.cmm_how_to_use__accordion_filter').text('本ページの説明を表示する');
      }
    });
  });

  // UGC連携 / ユーザーネーム登録のoverlay用
  $('.cmm_username_input__modal_bg').on('click', function () {
    $('.cmm_username_input__modal_bg').css('display', 'none');
    $('.cmm_username_input__modal_container').css('display', 'none');
    $('body').css('overflow', 'auto');
  });

  // .cmm_ugc_set_btnを押したときの処理 username矯正入力及び連携モーダルを出現させる
  $('.cmm_ugc_set_btn')
    .off()
    .on('click', function () {
      $('body').css('overflow', 'hidden'); // Disable scrolling
      $('.cmm_username_input__modal_bg').css('display', 'block');

      // username取得のためリンクを貼る
      let permalink = $(this).attr('data-permalink');
      $('.cmm_username_input__redirect_url').attr('href', permalink);

      let username = $(this).attr('data-username');
      username = username ? username : '';
      $('.cmm_username_input__input').val(username);

      let official_comment = $(this).attr('data-comment');
      official_comment = official_comment ? official_comment : '';
      $('.cmm_official_comment_input').val(official_comment);

      // 初期化処理
      $('.cmm_username_input__notice_message').remove();
      $('.cmm_username_input__warning_message').remove();
      $('.cmm_username_input__modal_submit').css({ 'pointer-events': 'auto', background: 'blue' });

      if (username) {
        // $('.cmm_username_input__modal_submit').css({ 'pointer-events': 'none', background: 'gray' });
        $('.cmm_username_input__input').before("<div class='cmm_username_input__notice_message'>※ユーザーネームはすでに登録されています。<br>ユーザーネームに誤りがある場合のみ<br>再登録してください。</div>");
      } else if (!username) {
        $('.cmm_username_input__modal_submit').css({ 'pointer-events': 'none', background: 'gray' });
        $('.cmm_username_input__input').before("<div class='cmm_username_input__warning_message'>※ユーザーネームが登録されていません。<br>登録完了後、連携ボタンを利用できます。</div>");
      }

      $('.cmm_username_input__modal_container').css('display', 'block');

      let sns_post_id = $(this).data('id');
      $('.cmm_username_input__modal_submit').attr('data-sns_post_id', sns_post_id);

      let parent_media_id = $(this).data('parent_media_id');
      $('.cmm_username_input__modal_submit').attr('data-parent_media_id', parent_media_id);

      let $this = $(this);

      // UGC group linking modal display
      $('.cmm_username_input__modal_del').on('click', function () {
        $('body').css('overflow', 'auto');
        $('.cmm_username_input__modal_container').css('display', 'none');
      });

      // ユーザーネームを手動登録
      $('.cmm_username_input__username_submit')
        .off()
        .on('click', function () {
          let input_username = $('.cmm_username_input__input').val();
          if (!input_username) {
            alert(`ユーザーネームが入力されていません。`);
            return;
          }
          $.ajax({
            url: '/cmm_save_manual_ugc_username',
            type: 'POST',
            data: {
              sns_post_id: sns_post_id,
              parent_media_id: parent_media_id,
              input_username: input_username,
            },
            dataType: 'json',
          })
            .done(function (data) {
              alert('ユーザーネームが登録されました。');
              // location.reload();
              // 連携するボタンを押せるようにする
              $('.cmm_username_input__modal_submit').css({ 'pointer-events': 'auto', background: 'blue' });
              $('body').css('overflow', 'auto');
              $this.closest('.cmm_tag_container').find('.cmm_ugc_username > p').text(input_username);
              // カルーセルに属する全ての投稿のユーザー名を一度に変更する
              if (parent_media_id) {
                $(`div[data-parent_media_id="${parent_media_id}"]`).each((index, el) => {
                  $(el).closest('.cmm_tag_container').find('.cmm_ugc_username > p').text(input_username);
                });
              }
              location.reload();
            })
            .fail(function () {
              alert('ユーザーネームの登録に失敗しました。再度お試しください。');
              $('body').css('overflow', 'auto');
            });
        });

      // 企業からのコメント登録
      $('.official_comment_submit')
      .off()
      .on('click', function () {
        let input_comment = $('.cmm_official_comment_input').val();
        if (!input_comment) {
          alert(`企業からのコメントが入力されていません。`);
          return;
        }
        $.ajax({
          url: '/cmm_save_ugc_official_comment',
          type: 'POST',
          data: {
            sns_post_id: sns_post_id,
            input_comment: input_comment,
          },
          dataType: 'json',
        })
          .done(function (data) {
            alert('企業からのコメントを登録しました。');
            $('body').css('overflow', 'auto');
            location.reload();
          })
          .fail(function () {
            alert('処理に失敗しました。再度お試しください。');
            $('body').css('overflow', 'auto');
          });
      });

      // UGC連携
      $('.cmm_username_input__modal_submit')
        .off()
        .on('click', function () {
          let ugc_group_ids = [];
          $('input[name=ugc_groups]:checked').each(function () {
            ugc_group_ids.push($(this).val());
          });
          if (ugc_group_ids.length == 0) {
            alert('Please select a UGC group.');
            return;
          }
          $.ajax({
            url: '/ugc_group_id_set',
            type: 'POST',
            data: {
              sns_post_id: sns_post_id,
              ugc_group_ids: ugc_group_ids,
              // コミュニケーション管理画面でUGC登録したときに、ugc_permissionの状態を変更することを知らせるflag
              cmm_change_ugc_permission_state_flag: 1,
            },
            dataType: 'json',
          }).done(function (data) {
            if (data.ret == '0') {
              // alert('Linked to UGC group.');
              $.ajax({
                url: '/cmm_update_ugc_permission',
                type: 'POST',
                data: {
                  sns_post_id: sns_post_id,
                  // コミュニケーション管理画面でUGC登録したときに、ugc_permissionの状態を変更することを知らせるflag
                  // cmm_change_ugc_permission_state_flag: 1,
                },
                dataType: 'json',
              })
                .done(function (data) {
                  // alert('Linked to UGC group.');
                  // alert(
                  //   `指定されたUGCグループに本投稿を連携しました。
                  //    本投稿のラベルの状態を自動的に"連携済み"に変更します。`.trim()
                  // );
                  // 改行を残してそれ以外の不要な空白を削除する
                  alert(
                    `指定されたUGCグループに本投稿を連携しました。
                    本投稿のラベルの状態を自動的に"連携済み"に変更します。`.replace(/[ \t]/g, '')
                  );
                })
                .fail(function () {
                  alert(
                    `指定されたUGCグループに本投稿を連携しました。

                    Notice:
                    予期しないエラーにより、本投稿のラベルの状態を自動的に"連携済み"に変更できませんでした。

                    お手数ですが、手動で本投稿のラベルの状態を"連携済み"にしていただくようお願い致します。`.replace(/[ \t]/g, '')
                  );
                })
                .always(function () {
                  location.reload();
                });
            }
          });
        });

      $('.cmm_username_input__modal_cancel_submit').on('click', function () {
        let ugc_group_id = $('.cmm_username_input__ugc_modal_select option:selected').val();

        $.ajax({
          url: '/ugc_group_id_delete',
          type: 'POST',
          data: {
            sns_post_id: sns_post_id,
          },
          dataType: 'json',
        }).done(function (data) {
          if (data.ret == '0') {
            alert('UGC group link has been removed.');
            location.reload();
          }
        });
      });
    }); // end $('.cmm_ugc_set_btn') click

  // .cmm_ugc_set_btnを押したときの処理 username矯正入力及び連携モーダルを出現させる
  $('.cmm_csv_download_btn')
    .off('click')
    .on('click', function () {
      $('.cmm_csv_download_btn').css({ 'pointer-events': 'none', 'background-color': 'gray' });
      $.ajax({
        url: '/cmm_download_csv_file',
        type: 'GET',
        data: {
          no_data: 'no_data',
        },
        // dataType: 'json',
        dataType: 'text', // <-- change this from 'json' to 'text'
      })
        .done(function (data) {
          // 改行を残してそれ以外の不要な空白を削除する
          alert(`CSVファイルのダウンロードを開始します。`.replace(/[ \t]/g, ''));
          // ajaxを通じてcsvダウンロードはできないため下記のようにしてcsvファイルをブラウザでダウンロードさせる
          let blob = new Blob([data], { type: 'text/csv' });
          let url = window.URL.createObjectURL(blob);
          let a = document.createElement('a');
          a.href = url;
          // ファイル名
          a.download = `ugc_list_${time_now_as_YYYYMMDDHHMMSS()}.csv`;
          a.click();
        })
        .fail(function (jqXHR, textStatus, errorThrown) {})
        .always(function () {
          // location.reload();
          $('.cmm_csv_download_btn').css({ 'pointer-events': 'auto', 'background-color': 'orange' });
        });
    });

  // webhook連携ができていない場合の処理 コミュニケーション管理を使用できないようにしている
  if ($('.cmm_no_insta_page_id_overlay').length > 0) {
    $('body').css({ overflow: 'hidden' });
    $('.cmm_csv_download_btn').off('click');
    // $('.cmm_csv_download_btn').css({ 'pointer-events': 'none' });
    $('.cmm_csv_download_btn').html(`本ページを利用するためには<a class="cmm_to_account_edit" href="/account_edit" style="position:relative; z-index:2000;">アカウント設定</a>より連携を完了させてください。</p>`);
    $('.cmm_csv_download_btn').css({
      position: 'fixed',
      left: '50%',
      top: '40%',
      transform: 'translate(-50%, -50%)',
      'font-size': '20px',
      padding: '5px',
      background: '#ff851f',
      cursor: 'default',
      'z-index': '20000',
      width: '900px',
      height: '200px',
      'text-align': 'center',
      margin: 'auto',
      opacity: '0.9',
      display: 'flex',
      'justify-content': 'center',
      'align-items': 'center',
    });
    $('.cmm_to_account_edit').css({
      margin: '0',
      padding: '0',
      'font-size': '25px',
      'vertical-align': 'baseline',
      background: 'transparent',
      'font-weight': 'bold',
      color: '#3030ea',
      'border-bottom': 'solid 2px #3030ea',
    });
    // $('.cmm_csv_download_btn').css({ background: 'black' });
  }

  // 現在の表示数を表示する
  main_object = $('.cmm_tag_container .post_tag_card').length || 0;
  $('#cmm_main__answered_ugc_count').text(main_object);

  sub_object = $('.cmm_sub__waiting_ugc_list_container .post_tag_card').length || 0;
}); // end of document.addEventListener("turbolinks:load", function () {
